<template>
  <a-row class="relation" align="bottom" :style="rowHeight">
    <a-row class="max1200" align="bottom">
      <a-row style="margin: 0px;" v-if="items.length > 0">

        <a-col v-for="(item, index) in items" :key="index" class="relation-item">
              <a v-on:click="genCorrelation(item, index)">
                <span>{{item.name}}</span>
              </a>
        </a-col>

        <a-col class="relation-img" @mouseover="showRelationItem" @mouseout="hideRelationItem">
          <a style="background-color: #f5f6f5; border: 0px; padding: 0px;" v-on:click="toggleRelationItem"> 
            <a-icon :component="CorrelateIcon"  :style="styleCI"/>
          </a>
        </a-col> 

        <a-col v-if="list_panel" class="item-tabs" @mouseover="showList" @mouseout="hideRelationItem"> 
          <a-row style="padding: 8px; background-color: #f5f6f5;">
            <a-row v-for="(item, index) in relationitem" :key="index" style="padding: 2px 0px;">
              <a-tag closable @close="deleteItem(index)">
                {{item}}
              </a-tag>
            </a-row>
          </a-row>
        </a-col>
      </a-row>
    </a-row>
  </a-row>
</template>

<script>

import CorrelateIcon from '@/assets/img/correlate.vue'

export default {
  name: 'RelationTab',
  props: {
    items: Array,
    default: function() {
      return []
    }
  },
  data() {
    return {
      CorrelateIcon, 
      styleCI: "height:24px; width:24px;", 
      rowHeight: { height: "32px" },  
      list_panel: false,
      relationitem: [],
      timer: ""
    }
  },
  methods: {
    genCorrelation: function(item, index) {
      this.$emit('computerelation', item)
    },
    showRelationItem: function() {
      clearTimeout(this.timer)
      this.list_panel = true
      this.relationitem = this.$store.getters.getRelationItem()
    },
    hideRelationItem: function(timeout) {
      let that = this
      if (timeout == null || timeout <=0 ) 
        timeout = 1500; 

      this.timer = setTimeout(function() {
        that.list_panel = false
      }, timeout)

      this.rowHeight =  { height: "32px" }; 
    },
    toggleRelationItem: function () {
      if (this.list_panel) 
        this.hideRelationItem(1); //immediately hide the panel
      else
        this.showRelationItem();
    }, 
    showList: function () {
      clearTimeout(this.timer)
    },
    deleteItem: function(item) {
      delete this.relationitem[item]
      let result = this.$store.getters.getResult()
      for(let i = 0; i < result.length; i++) {
        let data = result[i]
        if (data) {
          for (let key in data) {
            if (data[key] ==  item) {
              result[i]['checked'] = false
            }
          }
        }
      }
      let tab = this.$store.getters.getTab()
      this.$store.commit('updateresult', {result: result, tab: tab});
      this.$store.commit('updaterelationitem', this.relationitem)
      this.$emit('deleteitem')
    }
  }
}
</script>

<style scoped>
  .relation {
    width: 100%; 
    position: fixed; 
    height: 200px;
    bottom: 232px;
  }
  .max1200 {
    max-width: 1200px; 
    margin: auto;
  }
  .relation-list {
    float: right; 
    width: 45px;
    background-color: #f5f6f5;
  }
  .relation-img {
    float: right; 
    width: 24px; 
    height: 32px; 
    background-color: #f5f6f5; 
    padding: 6px 0px 0px 0px;
  }
  .relation-img:hover {
    cursor: pointer;
  }
  .relation-item {
    float: right;
    padding: 6px 2px 0px 2px;
    width: 40px;
    height: 32px; 
    background-color: #f5f6f5
  }
  .item-tabs {
    float: right;
    height: 198px;
    overflow: scroll;
    text-align: left; 
    margin: 0px 0px;
  }
</style>
